import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';
import './ActiveList.css';
import { getTodes as Service, getAreaDrClinicList,getAreaDrClinicFilterList,ServiceDivisionOverview } from "../Services/Service";
import ReactPaginate from "react-paginate";
import { bottom } from '@popperjs/core';

function ActiveList() {

    const [serviceData, setServiceData] = useState([]);

    const [areaData, setAreaData] = useState([]);
    const [drData, setDrData] = useState([]);
    const [clinicData, setClinicData] = useState([]);

    const [areaSelect, setAreaSelect] = useState('');
    const [drSelect, setDrSelect] = useState('');
    const [clinicSelect, setClinicSelect] = useState('');

    const [filterval, setfilterval] = useState([]);
    const [items, setItems] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setpageCount] = useState(100);
    const [limit, setLimit] = useState(50);
    const [totalData, setTotalData] = useState('');

    const [totalValues,setTotalValues] = useState({areaTotal:0,clinicTotal:0,doctorTotal:0});


    useEffect(() => {

        fetchAreaClinicDr();
        fetchActiveList(areaSelect, drSelect, clinicSelect, 1, limit);

    }, []);


    const fetchAreaClinicDr = async () => {
        getAreaDrClinicList()
            .then((res) => {
                
                setAreaData(res.data.data.area);
                setClinicData(res.data.data.clinic);
                setDrData(res.data.data.doctor);
                setTotalValues({...totalValues, ['areaTotal']: res.data.data.area.length,['clinicTotal']: res.data.data.clinic.length,['doctorTotal']:res.data.data.doctor.length});
                // console.log("drp",res.data.data.area);

    });
    }

    const fetchActiveList = async (areaSelect, drSelect, clinicSelect, currentPage,limit) => {
        //   alert("call");
        setCurrentPage(currentPage);
        // alert(currentPage);
        ServiceDivisionOverview(areaSelect, drSelect, clinicSelect, currentPage,limit)
            .then((res) => {
                console.log(res.data.data)
                setServiceData(res.data.data);
                
                if (currentPage == 1) {
                    setTotalData(res.data.total);
                    setpageCount(Math.ceil(res.data.total / limit));
                }
            }
            );
        // console.log("data", serviceData);

    }
    // console.log("area",areaSelect);
    function filterTableData(event) {
         
        console.log(event.target.value);
        let selectId = event.target.id;
        let selectVal = event.target.value;
        let areaVal = areaSelect;
        let drVal = drSelect;
        let clinicVal = clinicSelect;

        if (selectId == 'selectArea') {
            setAreaSelect(selectVal);
            areaVal = selectVal;
        }

        if (selectId == 'selectDr') {
            setDrSelect(selectVal);
            drVal = selectVal;
        }

        if (selectId == 'selectClinic') {
            setClinicSelect(selectVal);
            clinicVal = selectVal;
        }

        fetchActiveList(areaVal, drVal, clinicVal, 1,limit);
  
    }
    


    const fetchList = async (event) => {
        let pg = event.selected + 1;
        console.log(pg);
        fetchActiveList(areaSelect, drSelect, clinicSelect, pg, limit);

    };

    return (
        <section className='projects-section'>
            <div className='row'>
        <div className="FL">
            <div className="row mb-3 align-items-center displayFlex">
                <div className="col-md-6">
                    <h1 className="title">Division Overview</h1>
                </div>
                {/* <div className="col-md-2">
                    <select id="selectArea" name="selectArea" className='form-control' onChange={filterTableData} >
                        <option value="">-- SELECT DIVISION --</option>
                        {areaData.map((data, i) => (
                            <option key={i} value={data.areaId}>{data.areaName}</option>
                        ))}
                    </select>
                </div>
                <div className="col-md-2">
                    <select id="selectClinic" name="selectClinic" className='form-control' onChange={filterTableData} >
                        <option value="">-- SELECT PRACTICE --</option>
                        {clinicData.map((data, i) => (
                            <option key={i} value={data.clinicId}>{data.name}</option>
                        ))}
                    </select>
                </div>
                <div className="col-md-2">
                    <select id="selectDr" name="selectDr" className='form-control' onChange={filterTableData} >
                        <option value="">-- SELECT DOCTOR --</option>
                        {drData.map((data, i) => (
                            <option key={i} value={data.doctorId}>{data.drName}</option>
                        ))}
                    </select>
                </div> */}

                
            </div>
            <div className="row mb-3 align-items-center">
                {/* <div className="col-md-2"><h5>Total - {totalData}</h5></div> */}
                <div className="col-6 col-md-3"><h5>Division - <Link to="/area-list">{totalValues.areaTotal}</Link></h5></div>
                <div className="col-6 col-md-3"><h5>Practice - <Link to="/practice-list">{totalValues.clinicTotal}</Link></h5></div>
                {/* <div className="col-md-2"><h5>Doctor - <Link to="/doctor-list">{totalValues.doctorTotal}</Link></h5></div> */}
            </div>
            <div className='table-responsive'>
            <MDBTable align='middle'>
                <MDBTableHead>
                    <tr className="table-head">
                        <th scope='col'>Division Name</th>
                        <th scope='col'>Practice Name</th>
                        {/* <th scope='col'>Doctor Name</th> */}
                       
                    </tr>
                </MDBTableHead>
                <MDBTableBody>

                    {
                        Object.entries(serviceData).map( ([k,v],i) => 
                            
                            (<tr key={i}>
                                <td>{k}</td>
                                <td>
                                    <table><tbody>
                                {v.map((data, j) => (
                                    <tr className={j%2==0 ? 'nested-td-an' : 'nested-td-white'} key={j}>
                                        <td> {data.name}</td>
                                    </tr>
                                ))}
                                </tbody>
                                </table>
                                </td>
                            </tr>
                            )
                        )
                    
                    }
                    {/* {serviceData.map((data, i) => (
                        <tr key={i}>
                            <td>{data.areaName}</td>
                            <td>{data.name}</td>
                            <td>{data.drName}</td>
                        </tr>
                    ))} */}

                </MDBTableBody>
            </MDBTable>
            </div>
            <div className="col-md-12 mt-4">
            <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                breakLabel={"..."}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={fetchList}
                containerClassName={"pagination justify-content-center  pagination-sm"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
            />
        </div>
        </div>
        </div>

        </section>

    );
}
export default ActiveList;